import { memo } from "react";
import { Link } from "react-router-dom";
import { SidebarMenuItem as UISidebarMenuItem, SidebarMenuButton } from "@/components/ui/sidebar";
import type { MenuItem } from "./menuConfig";

interface SidebarMenuItemComponentProps {
  item: MenuItem;
  isActive: boolean;
  isCollapsed: boolean;
  count?: number;
}

export const SidebarMenuItemComponent = memo(function SidebarMenuItemComponent({
  item,
  isActive,
  isCollapsed,
  count = 0,
}: SidebarMenuItemComponentProps) {
  const Icon = item.icon;
  const showCount = count > 0;
  const displayCount = count > 99 ? "99+" : String(count);

  return (
    <UISidebarMenuItem>
      <SidebarMenuButton asChild isActive={isActive} tooltip={item.label}>
        <Link to={item.href} className="relative">
          <span className="relative inline-flex">
            <Icon className="h-4 w-4" />
            {showCount && isCollapsed && (
              <span
                aria-label={`${count} pendência(s)`}
                className="absolute -top-1.5 -right-1.5 min-w-[14px] h-[14px] px-1 rounded-full bg-destructive text-destructive-foreground text-[9px] font-bold leading-none flex items-center justify-center ring-1 ring-sidebar"
              >
                {displayCount}
              </span>
            )}
          </span>
          <span>{item.label}</span>
          {!isCollapsed && showCount && (
            <span
              aria-label={`${count} pendência(s)`}
              className="ml-auto min-w-[18px] h-[18px] px-1.5 rounded-full bg-destructive text-destructive-foreground text-[10px] font-bold leading-none flex items-center justify-center"
            >
              {displayCount}
            </span>
          )}
          {!isCollapsed && !showCount && item.badge && (
            <span className="ml-auto rounded-full bg-sidebar-foreground/20 text-sidebar-foreground text-[10px] font-semibold px-1.5 py-0.5">
              Novo
            </span>
          )}
        </Link>
      </SidebarMenuButton>
    </UISidebarMenuItem>
  );
});
